import { render, staticRenderFns } from "./IssueSeverityChip.vue?vue&type=template&id=ed747d88&scoped=true"
import script from "./IssueSeverityChip.vue?vue&type=script&lang=js"
export * from "./IssueSeverityChip.vue?vue&type=script&lang=js"
import style0 from "./IssueSeverityChip.vue?vue&type=style&index=0&id=ed747d88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed747d88",
  null
  
)

export default component.exports